import styled from "styled-components"
import { Button, Checkbox, Select,Card } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { MyText } from "../../../components";

export const RecommendationsContainer = styled.div`
  font-family: 'Nunito';

  font-size: 18px;

  h2{
    font-size: 22px;
  }
  
  h3{
    font-size: 20px;
  }
  
  p, li{
    font-size: 18px !important;
  }
`

export const YesButton = styled.button<{ isSelected: boolean }>`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid rgba(0, 167, 75, 1);
  background-color: ${({ isSelected }) => (isSelected ? 'rgba(0, 167, 75, 1)' : 'initial')};
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 167, 75, 1);
    
    span {
      color: white;
    }
  }

  span {
    color: ${({ isSelected }) => (isSelected ? 'white' : 'rgba(0, 167, 75, 1)')}; 
  }
`;

export const NoButton = styled.button<{ isSelected: boolean }>`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 4px solid rgba(230, 101, 89, 1);
  background-color: ${({ isSelected }) => (isSelected ? 'rgba(230, 101, 89, 1)' : 'initial')};
  cursor: pointer;

  &:hover {
    background-color: rgba(230, 101, 89, 1);

    span {
      color: white;
    }
  }

  span {
    color: ${({ isSelected }) => (isSelected ? 'white' : 'rgba(230, 101, 89, 1)')}; 
  }
`;

export const ButtonText = styled.span<{ weight: number; size: number; color: string }>`
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => size}px;
  color: ${({ color }) => color};
  text-align: center;
  line-height: 40px;
`;

export const CustomCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    width: 40px !important;
    height: 40px !important;
    border-radius: 11px !important;
    border: 2px solid !important;
    border-color: rgba(229, 233, 242, 1) !important;
    transition: all 0.3s ease;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: rgba(255, 149, 0, 1) !important;
    border-color: rgba(255, 149, 0, 1) !important;
  }

  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: rgba(255, 166, 41, 1) !important;
    border-color: rgba(255, 166, 41, 1) !important;
  }

  .ant-checkbox-inner:hover {
    background-color: rgba(255, 166, 41, 1) !important;
    border-color: rgba(255, 166, 41, 1) !important;
  }

  .ant-checkbox-inner:focus {
    border-color: rgba(255, 149, 0, 1) !important;
  }

  .ant-checkbox-inner::after {
    width: 12px !important;
    height: 18px !important;
  }

  .ant-checkbox-wrapper-checked:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner {
    background-color: rgba(255, 149, 0, 1) !important;
    border-color: rgba(255, 149, 0, 1) !important;
  }
`;


export const StyledButton = styled(Button)`
  background: rgba(231, 250, 255, 1) !important;
  border: none !important;
  padding: 25px 16px !important;
  border-radius: 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: rgba(0, 189, 244, 1) !important;

    .anticon {
      color: white !important;
    }

    .content {
      color: white !important;
    }
  }
`;

export const StyledIcon = styled(CheckCircleOutlined)`
  color: rgba(0, 141, 210, 1);
`;

export const StyledMyText = styled(MyText)`
  color: rgba(0, 141, 210, 1) !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  line-height: 24px !important;
`;

export const StyledSelect = styled(Select)`
  .ant-select-selection-placeholder {
    font-size: 18px !important;
  }
  .ant-select-selection-item {
    font-size: 18px !important;
  }
`;

export const StyledCard = styled(Card)`
  padding: 0 !important;
  
  .ant-card-body {
    padding: 0 !important; 
  }

  .ant-table-wrapper .ant-table-thead >tr>th {
    background: rgba(244, 245, 247, 1) !important;
  }

   .ant-table-container table>thead>tr:first-child >* {
   border-radius: 0 !important;
   height: 72px;
   border: 1px solid rgba(229, 233, 242, 1);
   }

   .ant-table-cell {
   height: 72px;
   }

   .ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
   display: none;
}
`;